export default __webpack_public_path__ + "static/media/right-leaf.bebf0433.svg";